const tenantroles = {
	title: "Klient roller",
	new_tenantrole: "Ny klient rolle",
	edit_tenantrole: "Rediger klient rolle: {name}",
	view_tenantrole: "Vis klient rolle: {name}",
	list_title: "Klient roller",
	list_subtitle: "Håndter klient rolle",
	create_title: "Ny klient rolle",
	update_title: "Oppdater klient rolle",
	id: "ID",
	name: "Navn",
	slug: "Slug",
};
export default tenantroles;